import { UiGroupControl } from '../controls/ui-group-control.model';
import { BaseControl } from '../controls/base-control.model';
import { ViewRowControl } from '../controls/view-row-control.model';

export class ViewControl {

  title: string;
  //rows: ViewRowControl[] = [];
  controls: BaseControl[] = [];

  constructor(title: string) {
    this.title = title;
  }

}
